module.exports = __webpack_public_path__ + "static/media/mterra.fe430d93.pdf";